import { UzCombobox } from '@utazzo/ui';

import { usePickerOptions } from './usePickerOptions';

import * as cuisinesApi from '@/features/cuisines/cuisines.api';

interface CuisinePickerProps {
  label?: string;
  value: string | null;
  onValueChange: (value: string | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
}

export const CuisinePicker = ({
  label = 'Cuisine',
  value,
  onValueChange,
  required,
  disabled,
  error,
  hint,
}: CuisinePickerProps): React.JSX.Element => {
  const { options, loading, setSearch } = usePickerOptions(
    {
      cacheKey: 'picker.cuisines',
      fetch: async (search) => {
        const res = await cuisinesApi.listCuisines({
          page: 1,
          pageSize: 30,
          sortDir: 'asc',
          ...(search ? { search } : {}),
        });
        return res.data;
      },
      fetchOne: async (id) => {
        try {
          return await cuisinesApi.getCuisine(id);
        } catch {
          return null;
        }
      },
      toOption: (c) => ({
        value: c.id,
        label: c.name,
        description: c.region ?? undefined,
      }),
    },
    value,
  );

  return (
    <UzCombobox
      label={label}
      placeholder="Select a cuisine"
      searchPlaceholder="Search cuisines..."
      value={value ?? ''}
      onValueChange={(v) => onValueChange(v || null)}
      onSearchChange={setSearch}
      options={options}
      loading={loading}
      required={required}
      disabled={disabled}
      error={error}
      hint={hint}
    />
  );
};
